import classnames from 'classnames';
import { config } from 'lib-shared-backend-config';
import { Component } from 'react';
import { noop } from 'ts-essentials';

import { ajaxSend } from '../../../api/api';

import './style/image.less';

export type ImageProps = {
  src?: string | any;
  wrapperClassName?: string | null;
  className?: string | null;
  speed?: string | null;
  alt?: string | null;
  onLoad?: (string) => void;
  onErrorHandler?: (error: string) => void;
  onClick?: (src?: string) => void;
};
type StatePropsType = {
  imageHolder: string;
  imageStyle: {
    transition: string;
    opacity: number;
  };
  alt?: string | null;
  src?: string;
};

class Image extends Component<ImageProps, StatePropsType> {
  constructor(props: ImageProps) {
    super(props);

    let opacity = 0;

    if (
      props.src === '' ||
      (props.src && !props.src.match(/http/)) ||
      typeof window === 'undefined'
    ) {
      opacity = 1;
    }

    this.state = {
      imageHolder: '',
      imageStyle: {
        transition: 'opacity ' + props.speed + 's',
        opacity: opacity,
      },
      alt: props.alt,
    };
    this.handleOnLoad = this.handleOnLoad.bind(this);
    this.handleOnError = this.handleOnError.bind(this);
  }

  fetchPrivateFile = (src: string) => {
    ajaxSend({
      path: src,
      responseType: 'blob',
    })
      .then((blob: any) => {
        const blobURL = window.URL.createObjectURL(blob);
        this.setState({
          src: blobURL,
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  _handleSrc = (src) => {
    if (
      typeof src === 'string' &&
      src.includes(
        `${config.url.files.replace('https://', '').replace('/', '')}/private`,
      )
    ) {
      this.fetchPrivateFile(src);
    } else {
      this.setState({ src });
    }
  };

  UNSAFE_componentWillMount() {
    this._handleSrc(this.props.src);
  }

  UNSAFE_componentWillReceiveProps(newProps: ImageProps) {
    if (newProps.src !== this.props.src) {
      this._handleSrc(newProps.src);
    }
  }

  handleOnLoad() {
    const { onLoad } = this.props;
    const { src } = this.state;

    this.setState({
      imageStyle: {
        transition: 'opacity ' + this.props.speed + 's',
        opacity: 1,
      },
      imageHolder: 'loading-complete',
    });

    if (src && onLoad) onLoad(src);
  }

  handleOnError(error: any) {
    this.setState({
      imageStyle: {
        transition: 'opacity ' + this.props.speed + 's',
        opacity: 0,
      },
      imageHolder: 'loading-error',
      alt: 'Error on image load',
    });
    if (typeof this.props.onErrorHandler === 'function') {
      this.props.onErrorHandler(error);
    }
  }

  render() {
    return (
      <span
        className={classnames(
          'loading-image',
          this.state.imageHolder,
          this.props.wrapperClassName,
        )}
        onClick={() => this.props.onClick?.(this.state.src)}
      >
        <img
          onError={this.handleOnError}
          onLoad={this.handleOnLoad}
          src={this.state.src}
          className={this.props.className as string}
          alt={this.props.alt as string}
          style={this.state.imageStyle}
        />
      </span>
    );
  }
}

(Image as any).defaultProps = {
  speed: 1,
  className: '',
  alt: '',
  onClick: noop,
};

export default Image;
